import { RefreshCw } from 'lucide-react';
import Link from 'next/link';
import i18n from '@/settings/i18n';
import { isTradeInAvailable } from '@/lib/trade-in';

const t = i18n.init('buyback');

const TradeInButton = () => {
  if (!isTradeInAvailable()) {
    return null;
  }

  return (
    <Link
      href="/buyback"
      prefetch={false}
      className="flex h-10 shrink-0 items-center gap-1.5 rounded-md border border-gray-700 px-2.5 text-[13px] font-semibold text-gray-700 outline-none"
    >
      <RefreshCw className="h-4 w-4" />
      <span className="whitespace-nowrap">{t`Trade-in`}</span>
    </Link>
  );
};

export default TradeInButton;
